import { formatTime, formatDate } from '../../filter'
import moment from 'moment'

// 约定的数据字段结构
/**
 * 获取编辑数据
 * @returns {
    key: string; // 字段名称
    label: string; // 字段显示名
    value: string; // 字段当前值。枚举值时用英文逗号分隔。已经设值和默认值都可通过当前字段实现。当字段类型为下拉列表等时，要映射到枚举值的展示值
    type: string; // 字段类型
    notNull: string; // 是否必填。0-非必填，1-必填
    enumCode: string; // enumCode":"对应枚举code。当type为下拉列表/选框时用
    length?: number; // 字段长度限制。当type为文本输入框时用
    maxValue?: number; // 最大值。type为数字时用
    minValue?: number; // 最小值。type为数字时用
    canEdit?: boolean; // 自定义的是否可编辑
    selectOption: any[]; // 自定义的下拉选项
    rules?: any[]; // 支持自定义校验规则
    spacialLabelWidth?: number; // 支持自定义label宽度
    symbol?: string; // 输入框后面的单位或符号
    button?: string; // 输入框后面的按钮
    btnFun?: Function; // 输入框后面的按钮
    labelSpan?: Function; // label的栅格比例
    wrapperSpan?: Function; // 内容的栅格比例
	formSpan?: number; // 表单的栅格比例
}
 */
function setTableHide(list, key, type) {
	for (const iterator of list) {
		// 对应值设置
		if (iterator.key == key) {
			iterator.type = type
		}
	}
}
export default function() {
	const res = this.checkParams()
	if (!res) {
		return
	}
	const { order, injured, setting } = this

	let livingInfoList = []
	if (injured.livingInfoList && injured.livingInfoList.length) {
		livingInfoList = injured.livingInfoList
	}

	const modal = [
		{
			label: '居住地区',
			value: '',
			key: 'homeAddress',
			type: 'searchSelect',
			selectOption: [],
			notNull: '1',
			canEdit: true,
			formSpan: 8,
		},
		{
			label: '详细地址',
			value: '',
			key: 'detailAddress',
			type: 'text',
			notNull: '1',
			canEdit: true,
			formSpan: 8,
			rules: [
				{
					max: 50,
					message: '长度不能超过50位',
					trigger: 'blur',
				},
			],
		},
		{
			label: '居住起止日期',
			value: [],
			key: 'dateArr',
			type: 'daterange',
			notNull: '1',
			canEdit: true,
			allowClear: false,
			formSpan: 8,
		},
		{
			label: '住房性质',
			value: '',
			selectOption: setting.houseNatureList,
			key: 'houseNature',
			type: 'select',
			notNull: '1',
			canEdit: true,
			formSpan: 8,
		},
		{
			label: '是否有居住证/暂住证',
			value: '',
			selectOption: setting.yesNoList,
			key: 'residencePermit',
			type: 'select',
			notNull: '1',
			canEdit: true,
			formSpan: 6,
			labelSpan: 14,
		},
		{
			label: '备注（非必填）',
			value: '',
			key: 'remark',
			type: 'text',
			notNull: '0',
			canEdit: true,
			formSpan: 8,
			rules: [
				{
					max: 100,
					message: '长度不能超过100位',
					trigger: 'blur',
				},
			],
		},
		{
			label: '居住起始日期',
			value: '',
			key: 'beginDate',
			type: 'hide',
			notNull: '1',
			canEdit: true,
			formSpan: 6,
		},
		{
			label: '居住截止日期',
			value: '',
			key: 'endDate',
			type: 'hide',
			notNull: '1',
			canEdit: true,
			formSpan: 6,
		},
	]

	const list = livingInfoList.map((item, index) => {
		let beginDate = item.beginDate
			? moment(formatDate(item.beginDate), 'YYYY-MM-DD')
			: ''
		let endDate = item.endDate
			? moment(formatDate(item.endDate), 'YYYY-MM-DD')
			: ''
		const valArr = [
			item.homeAddress,
			item.detailAddress,
			beginDate && endDate ? [beginDate, endDate] : [],
			item.houseNature,
			item.residencePermit,
			item.remark,
			beginDate,
			endDate,
		]
		if (item.houseNature == '02') {
			setTableHide(modal, 'residencePermit', 'hide')
		}
		let arr = modal.map((moadlItem, valIndex) => {
			let obj = {
				...moadlItem,
				value: valArr[valIndex],
			}
			// 组装工作地区列表数据
			if (obj.key == 'homeAddress') {
				obj.value =
					item.provinceCode + '-' + item.cityCode + '-' + item.areaCode
				obj.selectOption = [
					{
						key: item.provinceCode + '-' + item.cityCode + '-' + item.areaCode,
						value: item.homeAddress,
					},
				]
			}

			return obj
		})

		return {
			list: arr,
		}
	})

	const obj = {
		title: '伤者至少超过一年的完整居住经历',
		key: 'livingInfoList', // 提交时对应的字段
		modal: modal, // 每一行的模板
		children: list, // 数据列表
	}

	return obj
}
